<mat-dialog-content>
  <meg-audio-field #audioInput></meg-audio-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary" class="dialog-btn-left" (click)="closeAudioCapture()"><mat-icon>clear</mat-icon> {{'cancel' | translate}}</button>
  <button mat-raised-button color="accent" class="dialog-btn-right" (click)="saveAndCloseAudioCapture()" [disabled]="!audioInput.audioBase64"><mat-icon>save</mat-icon> {{'save' | translate}}</button>
</mat-dialog-actions>
